import { Reveal, Marquee, PhotoSlot, PageHero, useSettings, siteText } from "@/components/shared";

const CHAPTERS = [
  { n: "01", key: "story_01", title: "Nos origines" },
  { n: "02", key: "story_02", title: "Notre philosophie" },
  { n: "03", key: "story_03", title: "Notre cuisine" },
  { n: "04", key: "story_04", title: "Notre savoir-faire" },
  { n: "05", key: "story_05", title: "Nos valeurs" },
  { n: "06", key: "story_06", title: "Un lieu de rencontres" },
  { n: "07", key: "story_07", title: "Notre évolution" },
  { n: "08", key: "story_08", title: "Notre avenir" },
];

export default function Histoire() {
  const settings = useSettings();

  return (
    <div data-testid="histoire-page">
      <PageHero overline="Notre Histoire" title="Une histoire en huit chapitres" testId="histoire-hero" />

      <div className="px-6 pb-28 md:px-12 md:pb-40">
        <div className="mx-auto max-w-6xl space-y-28 md:space-y-40">
          {CHAPTERS.map((chapter, i) => (
            <Reveal key={chapter.n}>
              <div
                className={`grid items-center gap-12 lg:grid-cols-2 lg:gap-20 ${
                  i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
                }`}
                data-testid={`chapter-${chapter.n}`}
              >
                <div>
                  <span className="text-sm font-bold tracking-[0.3em] text-copper">
                    {chapter.n}
                  </span>
                  <h2 className="mt-4 text-3xl font-bold tracking-tight text-ivory sm:text-4xl">
                    {chapter.title}
                  </h2>
                  <p className="mt-6 max-w-lg whitespace-pre-line text-base leading-relaxed text-ivory/60">
                    {siteText(settings, chapter.key) || "Texte à venir."}
                  </p>
                </div>
                <PhotoSlot ratio="aspect-[4/3]" testId={`chapter-photo-${chapter.n}`} />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mx-auto mt-24 max-w-2xl text-center text-xl font-semibold leading-relaxed tracking-tight text-gold sm:text-2xl" data-testid="histoire-signature">
            Palais Maasaï — Bien plus qu'une adresse, un lieu de partage.
          </p>
        </Reveal>
      </div>

      <Marquee items={["Nos origines", "Notre philosophie", "Notre cuisine", "Nos valeurs", "Notre avenir"]} />
    </div>
  );
}
